import { render } from "./RevenueView.vue?vue&type=template&id=5f1377ea&scoped=true"
import script from "./RevenueView.vue?vue&type=script&lang=js"
export * from "./RevenueView.vue?vue&type=script&lang=js"

import "./RevenueView.vue?vue&type=style&index=0&id=5f1377ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1377ea"]])

export default __exports__